import { createContext, useContext, useState, useEffect } from 'react';

const STORAGE_KEY = 'ewio_fiat_currency';

const CurrencyContext = createContext({
  currency: 'usd',
  setCurrency: () => {},
});

export function CurrencyProvider({ children }) {
  const [currency, setCurrencyState] = useState(() => {
    try {
      const stored = localStorage.getItem(STORAGE_KEY);
      return stored === 'eur' ? 'eur' : 'usd';
    } catch {
      return 'usd';
    }
  });

  useEffect(() => {
    try {
      localStorage.setItem(STORAGE_KEY, currency);
    } catch {
      // ignore
    }
  }, [currency]);

  const setCurrency = (c) => {
    setCurrencyState(c === 'eur' ? 'eur' : 'usd');
  };

  return (
    <CurrencyContext.Provider value={{ currency, setCurrency }}>
      {children}
    </CurrencyContext.Provider>
  );
}

export function useCurrency() {
  const ctx = useContext(CurrencyContext);
  return ctx?.currency ?? 'usd';
}

export function useCurrencySetter() {
  const ctx = useContext(CurrencyContext);
  return ctx?.setCurrency ?? (() => {});
}
